//import React from 'react'
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import TraitChart from "./Charts/TraitChart";
import MoodChart from "./Charts/MoodChart";
import { RiFolderChartLine } from "react-icons/ri";
import { LuArrowUpRightSquare } from "react-icons/lu";
import SleepScore from "./Charts/SleepScore";
import EnergyPotential from "./Charts/EnergyPotential";
import mydashimg from "../../../assets/images/mydashboard.svg";
import { AwardIcon, CheckIcon, StarIcon } from "../../../SvgIconsData";
import memory from "../../../assets/images/memory.svg";
import { useSelector, useDispatch } from "react-redux";
import { backend_url } from "../../../env";
import MarkNowModal from "./MarkNowModal";
import intermediate from "../../../assets/images/timelines/intermediate.svg";
import Slider from "react-slick";
import Calendar from "./CustomCalender";
import fire from "../../../assets/images/icons/fire.svg";
import MoodConditions from "./MoodConditions";

const filterRangesText = {
  all: "sessions",
  week: "in the last week",
  month: "in the last month",
  year: "in the last year",
  "half-year": "in the last 6 months",
};

const MyDashboard = () => {

  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const [currentRange, setCurrentRange] = useState("all");

  const [graphcount, setgraphcount] = useState([]);

 

  const [mood, setMood] = useState(false);

  const [moodanalytics, setMoodAnalytics] = useState([]);

  const [streak, setStreak] = useState("");

  const [active, setActive] = useState(0);

  const [month, setMonth] = useState("")

  const [maxStreak, setMaxStreak] = useState(0)

  const [longestStreak, setLongestStreak] = useState(0)

  const userData = useSelector((state) => state.userSlice);

  var uuid = userData?.user?.uuid;

  var name = userData?.user?.name;

  const [dtraits, setdTraits] = useState([]);

  const configData = useSelector((state) => state.configSlice);

  const fetchdTraitsData = async () => {
    const reponse = await axios.get(`${configData?.config?.apiBaseUrl}/api/dtraits/${uuid}`, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      },
    });
    setdTraits(reponse.data.data);
  };

  const fetchMoodAnalytics = async () => {

    const reponse = await axios.get(
      `${configData?.config?.apiBaseUrl}/api/moodanalytics/${currentRange}/${uuid}`, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      },
    }
    );

    setMoodAnalytics(reponse?.data?.data?.Counts || []);

  };


  const fetchMoodToday = async () => {
    const response = await axios.get(`${configData?.config?.apiBaseUrl}/api/moodtoday/${uuid}`, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      },
    });
    setMood(response.data.data);
    if (response.data.data == true) {
      setShow(false);
    } else {
      setShow(true);
    }

  };

  const fetchgraphdata = async () => {
    const reponse = await axios.get(
      `${configData?.config?.apiBaseUrl}/api/traitcount/${uuid}/${currentRange}`, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      },
    }
    );
    setgraphcount(reponse.data);
  };

  const fetchanalytics = async () => {
    const response = await axios.get(
      `${configData?.config?.apiBaseUrl}/api/analytics/${uuid}/${currentRange}`, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      },
    }
    );
    setMaxStreak(response?.data?.data?.longestStreakLength || 0);
    setActive(response?.data?.data?.activeDaysLength || 0)

  };



  useEffect(() => {
    fetchMoodToday();
    fetchMoodAnalytics();
    fetchanalytics()
    fetchgraphdata();
  }, []);



  useEffect(() => {
    fetchdTraitsData();
    fetchgraphdata();
    fetchMoodAnalytics();
    fetchanalytics()
  }, [currentRange]);

  const handleShow = () => setShow(false);

  const handleClose = () => setShow(false);

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="container-fluid p-4">
        <div className="row pb-3">
          <div className="col-md-8">
            <h5>My Dashboard</h5>
          </div>
          <div className="col-md-4">
            <ul className="FilterDataRange">
              <li
                className={currentRange === "all" ? "active" : ""}
                onClick={() => setCurrentRange("all")}>
                All
              </li>
              <li
                className={currentRange === "week" ? "active" : ""}
                onClick={() => setCurrentRange("week")}>
                W
              </li>
              <li
                className={currentRange === "month" ? "active" : ""}
                onClick={() => setCurrentRange("month")}>
                M
              </li>
              <li
                className={currentRange === "half-year" ? "active" : ""}
                onClick={() => setCurrentRange("half-year")}>
                6M
              </li>
              <li
                className={currentRange === "year" ? "active" : ""}
                onClick={() => setCurrentRange("year")}>
                Y
              </li>
            </ul>
          </div>
        </div>
        <div className="row insights">
          <div className="col-lg-8">
            <div className="card bg-light-blue position-relative mb-4 min-height-120 overflow-hidden">
              <div className="card-body">
                <div className="introcard d-flex gap-3 align-items-center">
                  <div>
                    {!mood ? (
                      <>
                        <h5 className="mb-1">How do you feel today? {name} </h5>
                        <p className="font-xs mb-0 color-light-blue">Please mark your mood today</p>
                        <button onClick={handleShow} className="btn btn-info btn-sm mt-3">
                          Mark Now <FaAngleRight />
                        </button>
                      </>
                    ) : (
                      <>
                        <h5 className="mb-1">Welcome Back! {name} </h5>
                        <p className="font-xs mb-0 color-light-blue">
                          Hurray! You have already marked your mood and sleep duration today.
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <img className="dashimg" src={mydashimg} alt="" />
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="card h-100">
                  <div className="card-body pb-0">
                    <h6>
                      Traits Chart{" "}
                      <span className="font-xss color-light">Track your most play traits</span>
                    </h6>
                    <div className="icons gap-2">
                      <SportsEsportsOutlinedIcon />{" "}
                      <h4 className="mb-0">
                        {graphcount.tsum}
                        <span className="font-xss color-light">
                          {" "}
                          {filterRangesText[currentRange]}
                        </span>
                      </h4>
                    </div>
                    <TraitChart currentRange={currentRange} />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body pb-0">
                    <h6 className="mb-0">
                      Mood Chart{" "}
                      <span className="font-xss color-light">Track your mood easily</span>
                    </h6>
                    <MoodChart moodanalytics={moodanalytics} currentRange={currentRange} />
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-4">
                <div className="card">
                  <div className="card-body">
                    <h6 className="font-xs">Your Traits</h6>
                    <div className="traitslist yourtraits flex-nowrap">
                      <Slider {...settings}>
                        {dtraits.length > 0 &&
                      
                          dtraits.map((item, index) => {
                            return (
                              <div key={index} >
                                <div
                                  className={`card  position-relative overflow-hidden mx-2 mb-2 ${item.trait.color}`}>
                                  <img
                                    src={item.trait.icon}
                                    className="cardimg"
                                    style={{ right: "0px", left: "inherit" }}
                                    alt=""
                                  />
                                  <div className="card-body">
                                    <p className="font-xss mb-2">
                                      <strong>{item.trait.name}</strong>
                                    </p>
                                    <div className="d-flex gap-1 align-items-center">
                                      <img
                                        src={item.interpretation?.icon}
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                          objectFit: "contain",
                                        }}
                                        alt=""
                                      />
                                      <p className="font-xss mb-1">{item.interpretation?.result}</p>
                                    </div>
                                    <div className="scoress d-flex align-items-center gap-1">
                                      <AwardIcon />
                                      <p className="mb-0 font-xss">Score: {item.medianScore}</p>
                                    </div>
                                    <div className="d-flex gap-2 pt-2">
                                      <span
                                        onClick={() =>
                                          navigate(`/traits/insights/${item.trait.id}/${uuid}`)
                                        }
                                        className="bg-white p-1 round-2 line-height1 cursor-pointer">
                                        <RiFolderChartLine />
                                      </span>
                                      <span
                                        onClick={() =>
                                          navigate(
                                            `/traits/playmodule/${item.trait?.games[0]?.id}`,
                                            {
                                              state: { tid: item.id },
                                            }
                                          )
                                        }
                                        className="bg-white p-1 round-2 line-height1 cursor-pointer">
                                        <LuArrowUpRightSquare />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card scorecarddesign text-center mb-4 overflow-hidden min-height-120">
              <div className="card-body">
                <div className="row">

                  <MoodConditions prop={graphcount.max} />

                  {/* <div className="col-md-6">
                    <h6>Sleep Score</h6>
                    <SleepScore graphcount={graphcount} currentRange={currentRange} />
                  </div> */}
                  {/* <div className="col-md-6">
                    <h6>Energy Potential </h6>
                    <EnergyPotential />
                  </div> */}
                </div>
              </div>
            </div>
            <h6>Statistics</h6>
            <div className="row pb-4">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <h4 className="statsticsicon">
                      {" "}
                      <span>
                        <CheckIcon />
                      </span>{" "}
                      {active}
                    </h4>
                    <p className="mb-0 font-xs">Active Days</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <h4 className="statsticsicon">
                      {" "}
                      <span>
                        <StarIcon />
                      </span>{" "}
                      {maxStreak}
                    </h4>
                    <p className="mb-0 font-xs">Longest Streak</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center justify-content-between">
                  <div className="col-md-8">
                    <h6 className="m-0">Daily Streak</h6>
                  </div>
                  <div className="col-md-4">
                    {longestStreak > 0 &&
                      <div className="d-flex align-items-center justify-content-end">
                        <h4 className="m-0">
                          <strong>{longestStreak}</strong>
                        </h4>
                        <img src={fire} style={{ width: "28px" }} alt="" />
                      </div>
                    }
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <Calendar setLongestStreak={setLongestStreak} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MarkNowModal show={show} handleClose={handleClose} />
    </>
  );
};

export default MyDashboard;
